import React from "react"

import { Col, Row } from "react-bootstrap"
import IconDescriptionCard from "./icon-description-card/icon-description-card"
import renderElement from "../../utils/renderElement"

const ColumnLayout = props => {
  return (
    <section className="three-column-content">
      <div className={props?.isBlog ? " " : "container"}>
        <Row>
          <Col className="col-12">
            {props.data.title && (
              <h2
                className="text-center mb-4"
                dangerouslySetInnerHTML={renderElement(props.data.title)}
              ></h2>
            )}
            {props.data.description && (
              <div
                dangerouslySetInnerHTML={renderElement(props.data.description)}
                className="text-center mb-4"
              ></div>
            )}
          </Col>
          {props.data.column_content.map((column, index) => {
            return (
              <IconDescriptionCard
                key={index}
                description={column.column_description}
                title={column.column_title}
                icon={column.column_imageicon}
              />
            )
          })}
        </Row>
      </div>
    </section>
  )
}

export default ColumnLayout
